export default "__VITE_ASSET__2d019ebe__"